import clipboard from 'copy-text-to-clipboard';
import Vue from 'vue';

const clipboardPlugin = {
	install() {
		Vue.clipboard = clipboard;
		Vue.prototype.$Clipboard = clipboard;
	}
};

Vue.use(clipboardPlugin);
